import { Store } from '../../../types';
import StoreCard from './store-card';

export default function StoreList({ stores }: { stores: Store[] }) {
    return (
        <div className="map-info">
            <div className="partners-items">
                {stores.map((s) => (
                    <StoreCard key={s.id} store={s} />
                ))}
            </div>
        </div>
    );
}
